import {AbstractModel} from "../abstract-model";
import {ParentRight} from '../../constants/parent-right';

export class Hierarchy extends AbstractModel {
  list: ParentRight[] = [ParentRight.USER, ParentRight.ADMIN, ParentRight.SUPER_ADMIN, ParentRight.DEV];

  ROLE_API_DEV: string[] = [];
  ROLE_API_SUPER_ADMIN: string[] = [];
  ROLE_API_ADMIN: string[] = [];
  ROLE_API_USER: string[] = [];

  // Famous "self-repair" feature
  deserializeRoles(roles: string[], parentRight: ParentRight): string[] {
    const deserializedRoles: string[] = [...this[parentRight]];

    for (const role of roles) {
      if (!deserializedRoles.includes(role) && role !== parentRight) {
        deserializedRoles.push(role);
      }
    }

    deserializedRoles.push(parentRight);

    return deserializedRoles;
  }
}
